import { cn } from "../lib/utils";
import { motion } from "framer-motion";

export const GlassCard = ({ children, className, neon = false, ...props }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={cn(
        "rounded-xl overflow-hidden relative",
        "backdrop-blur-xl bg-black/40",
        neon 
          ? "border border-cyan-500/30 shadow-[0_0_15px_rgba(0,243,255,0.15)]"
          : "border border-white/10 shadow-[0_8px_32px_0_rgba(0,0,0,0.37)]",
        className
      )}
      {...props}
    >
      {/* Corner accents */}
      <div className="absolute top-0 left-0 w-4 h-4 border-l-2 border-t-2 border-neon-cyan/50 rounded-tl-xl" />
      <div className="absolute top-0 right-0 w-4 h-4 border-r-2 border-t-2 border-neon-cyan/50 rounded-tr-xl" />
      <div className="absolute bottom-0 left-0 w-4 h-4 border-l-2 border-b-2 border-neon-purple/50 rounded-bl-xl" />
      <div className="absolute bottom-0 right-0 w-4 h-4 border-r-2 border-b-2 border-neon-purple/50 rounded-br-xl" />
      
      {children}
    </motion.div>
  );
};
